module.exports = __webpack_public_path__ + "static/img/products_normal.bde89bd6.jpg";